<template>
  <div class="preview-card--wrap" :class="{ activecard: active }">
    <div class="header--wrap" :class="{ active: active }">
      <div class="heading-wrap text-block-title">{{ heading }}</div>
      <fluent-icon
        v-if="active"
        icon="checkmark-circle"
        type="solid"
        size="24"
        class="checkmark"
      />
    </div>
    <div class="content-wrap">
      {{ content }}
    </div>
    <div class="image-wrap">
      <img :src="src" class="image" :class="{ activeimage: active }" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    heading: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: 'Active',
    },
    src: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-card--wrap {
  background-color: var(--conversa2-neutral-50-color);
  border-radius: var(--border-radius-normal);
  border: 1px solid var(--conversa2-neutral-200-color);
  display: flex;
  flex-direction: column;
  max-height: 34rem;
  max-width: 38rem;
  min-width: 24rem;

  .header--wrap {
    font-size: var(--font-size-default);
    line-height: var(--space-medium);
    font-weight: var(--font-weight-bold);
    background: var(--conversa2-neutral-100-color);
    border-bottom: 1px solid var(--conversa2-neutral-200-color);
    border-top-left-radius: var(--border-radius-normal);
    border-top-right-radius: var(--border-radius-normal);
    display: flex;
    height: 4rem;
    justify-content: space-between;
    padding: var(--space-small);
    width: 100%;
  }

  .active {
    background: var(--conversa2-blue-100-color);
    border-bottom: 1px solid var(--conversa2-blue-300-color);
  }

  .heading-wrap {
    align-items: center;
    display: flex;
    font-weight: var(--font-weight-bold);
    padding: var(--space-smaller);
  }

  .checkmark {
    color: var(--conversa2-blue-600-color);
  }

  .content-wrap {
    color: var(--conversa2-neutral-800-color);
    font-size: var(--font-size-small);
    line-height: var(--space-two);
    padding: var(--space-slab) var(--space-slab) 0 var(--space-slab);
    text-align: start;
  }

  .image-wrap {
    padding: var(--space-slab);
  }

  .image {
    border: 1px solid var(--conversa2-neutral-200-color);
    border-radius: var(--border-radius-normal);
  }

  .activeimage {
    border: 1px solid var(--conversa2-blue-200-color);
  }
}

.activecard {
  background: var(--conversa2-blue-50-color);
  border: 1px solid var(--conversa2-blue-300-color);
}
</style>
